import React from 'react';
import _ from 'lodash';
import { Input, Box } from '@kufox/mui';

import SendCodeBtn from '../SendCodeBtn';
import { useLang } from '../../hookTool';

function InputSendCode(props = {}) {
  const {
    placeholder,
    onChange = _.noop,
    onSendCode = _.noop,
    countTimeOver = _.noop,
    disabled,
    countTime,
    loading,
    value,
    size = 'large',
    startAdornment = null,
    ...reset
  } = props;

  const { t } = useLang();

  const handleSendCode = async () => {
    if (loading) return;
    onSendCode();
  };

  return (
    <Box display="flex" alignItems="center">
      <Input
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        size={size}
        addonBefore={startAdornment}
        {...reset}
      />
      <SendCodeBtn
        ml={8}
        style={{ flexShrink: 0 }}
        loading={loading}
        disabled={disabled}
        onChange={handleSendCode}
        countTime={countTime}
        countTimeOver={countTimeOver}
        countText={t('send')}
        size={size}
      />
    </Box>
  );
}
export default InputSendCode;
